import { getJquery } from '../js/util'

let $ = getJquery()

export default {
	init() {
		let shownIntlShippingNotice = false
		let $shippingCountryField = $('#shipping_country')
		let $billingCountryField = $('#billing_country')
		let $shipToDifferentCountry = $('#ship-to-different-address-checkbox')

		if ($shippingCountryField.length) {
			function showNotice() {
				let { intl_shipping_msg } = window.prof_checkout_vars
				if (shownIntlShippingNotice || !intl_shipping_msg) {
					return
				}
				window.swal(
					'Please Note',
					intl_shipping_msg
					// 'error'
				)
				shownIntlShippingNotice = true
			}

			if (
				$shippingCountryField.val() !== 'US' &&
				$shipToDifferentCountry.is(':checked')
			) {
				showNotice()
			} else if (
				$billingCountryField.val() !== 'US' &&
				!$shipToDifferentCountry.is(':checked')
			) {
				showNotice()
			}

			$shippingCountryField.on('change', function () {
				if (
					$shippingCountryField.val() !== 'US' &&
					$shipToDifferentCountry.is(':checked')
				) {
					showNotice()
				}
			})
			$billingCountryField.on('change', function () {
				if (
					$billingCountryField.val() !== 'US' &&
					!$shipToDifferentCountry.is(':checked')
				) {
					showNotice()
				}
			})
		}
	},
	finalize() {},
}
